import React from 'react';
import styled from 'styled-components';
import { hexToRgba } from '../../services/hex.service';
import { NOTIFICATION_ICON, NOTIFICATION_ICON_COLOR } from '../../constants/notification.constant';

interface EventIconProps extends React.AllHTMLAttributes<HTMLElement> {
  eventType: string;
  size: number;
  withoutBg?: boolean;
}

const StyledEventIcon = styled.div<{
  color?: string;
  size?: number;
  withoutBg?: boolean;
}>`
  display: flex;
  border-radius: 2px;
  width: ${({size}) => size ? `${size}px` : '42px'};
  height: ${({size}) => size ? `${size}px` : '42px'};
  align-items: center;
  margin-right: 4px;
  justify-content: center;
  background: ${({ color, theme,  withoutBg }) => withoutBg ? 'transparent' :
    hexToRgba(theme.colors[color || 'LABEL'], 0.1)};
  color: ${({ color, theme }) => theme.colors[color || 'LABEL']};
`;

const EventIconComponent = ({eventType, size, withoutBg}: EventIconProps) => {
  return (
    <StyledEventIcon
      color={NOTIFICATION_ICON_COLOR[eventType]}
      size={size}
      withoutBg={withoutBg}
    >
      {NOTIFICATION_ICON[eventType]}
    </StyledEventIcon>
  );
};

export default EventIconComponent;
